import { Component, OnInit, Input } from "@angular/core";
import {
  faUser,
  faUniversity,
  faUserCircle,
  faShoppingCart,
  faTicketAlt,
  faFileAlt,
  faTasks,
  faChevronDown,
  faCalendarAlt,
  faUsers
} from "@fortawesome/pro-solid-svg-icons";
import { ActivityLogsService } from "src/app/core/services/activity-logs/activity-logs.service";
import { PopoverController } from "@ionic/angular";
import { ActivityLogActionsComponent } from "./../activity-log-actions/activity-log-actions.component";
import {
  userSelectors
} from "src/app/core/ngrx/selectors";
import { select, Store } from "@ngrx/store";
import { State } from "src/app/core/ngrx/reducers";
import { ApplicationService } from "src/app/core/services/application/application.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-activity-log",
  templateUrl: "./activity-log.component.html",
  styleUrls: ["./activity-log.component.scss"]
})
export class ActivityLogComponent implements OnInit {
  faUser = faUser;
  faUniversity = faUniversity;
  faUserCircle = faUserCircle;
  // faComputerClassic = faComputerClassic;
  faShoppingCart = faShoppingCart;
  faTicketAlt = faTicketAlt;
  faFileAlt = faFileAlt;
  faTasks = faTasks;
  faChevronDown = faChevronDown;
  faCalendarAlt = faCalendarAlt;
  faUsers = faUsers;

  logsFromApi: any = "";
  logs: any = "";

  dateSortSelection: string = "Most recent";
  @Input() action: string;
  @Input() actionId: string;
  @Input() showSpinner: boolean = false;

  user$ = this.store.pipe(select(userSelectors.userProfile));
  user: any;
  adminList: any;
  selectedAdmins: any;

  actionTypes: any = {
    // profileAccount: false,
    // upload: true,
    // application: true,
    // payment: true,

    user: false, //Trainee Activity Log
    application: false, //Application Activity Log
    department: false, //Institution Activity Log
    program: false, //Program Activity Log
    payment: false, //Payment activity log
    host: false, //Host Activity Log
  }
  trueTypes: any;
  fetchingApi: boolean;

  constructor(private activityLogsService: ActivityLogsService,
    private popoverCtrl: PopoverController,
    private store: Store<State>,
    private applicationService: ApplicationService,
    private route: Router
    ) {

    }

  ngOnInit() {
    //console.log(this.action , this.actionId)
    if (this.action && this.actionId) {
      let query;
      if (this.action == "user") {
        query = { query: { action: ["user"], user_id: this.actionId } };
      } else if (this.action == "department") {
        query = {
          query: { action: ["department"], department_id: this.actionId }
        };
      } else if (this.action == "application") {
        query = {
          query: { action: ["application"], application_id: this.actionId }
        };
      } else if (this.action == "program") {
        query = { query: { action: ["program"], program_id: this.actionId } };
      } else if (this.action == "payment") {
        query = { query: { action: ["payment"], payment_id: this.actionId } };
      } else if (this.action == "host") {
        query = { query: { action: ["host"], host_id: this.actionId } };
      } else if (this.action == "all") {
        query = {query: {action: ["All"]}};
      }
      //query = {query: { }};

      //query = {query: {action: ["All"]}};

      //query = {"query":{"action":["application"],"application_id": "1d7e21d1-f46e-492b-b1ee-208fb91be729"}};

      //const query = { query: { action: ["user"], user_id: this.id } };
      //const query = {"query":{"action":["department"],"department_id":"1d251dd4-46a3-45ae-b4d4-5c9d59bd0170"}} //Institution  department
      //const query = {"query":{"action":["host"],"host_id":"69bd476c-b553-4634-bf52-fcdd276da224"}}; //host
      //const query = {"query":{"action":["program"],"program_id":5555551}}
      //const query = {"query":{"action":["payment"],"payment_id":"dfb4988d-1c0c-49c3-9bcf-a1029e21d855"}};

      // const query = {"query":{"action":["coupon"],"coupon_id":"0220ec03-3208-4f75-a267-ad62dc5775d2"}}
      // const query = {"query":{"action":["application"],"application_id":"72d60875-e62c-40ef-b571-33a90bed8a56"}}
      this.fetchingApi = true;
      this.activityLogsService.getActivityLogs(query).subscribe(
        (logsObj) => {
          // console.log("incoming ", logsObj);
          
          this.logsFromApi = logsObj;
          this.applyFilters(logsObj);
          this.fetchingApi = false;
        },
        (err) => {
          console.log("err", err);
          this.fetchingApi = false;
        }
      );
    }

    this.adminUsers();
  }

  adminUsers(){
    this.user$.subscribe((user: any) => {
      this.user = { ...user };
      if(user){
        //console.log(this.user.id)
        this.applicationService.findadminusers(this.user.id).subscribe((admins:any) =>{
          //console.log(admins);
          this.adminList = admins;
        })
      }
    });
  }

  applyFilters(logsObj: any){
    if (logsObj) {
      if (logsObj.results) {
        if (logsObj.results.length > 0) {
          //apply checkbox filter on data
          let logsTyped;
          if(this.trueTypes && this.trueTypes.length > 0){
            logsTyped = logsObj.results.filter((log:any) => this.trueTypes.indexOf(log.json_data.action) > -1 ) //log.json_data.action == 'user')
          } else{
            logsTyped = logsObj.results;
          }
          //apply admin filter on logsTyped
          let adminTyped;
          if(this.selectedAdmins && this.selectedAdmins.length>0){
            adminTyped = logsTyped.filter((log:any) => this.selectedAdmins.indexOf(log.json_data.actor_id) > -1 ) 
          }else{
            adminTyped = logsTyped;
          }
          //date filter on adminTyped final (logsTyped > )
          const dateFiltered = this.applyDateFilter(adminTyped);
          //most recent sort
          this.logs = this.mostRecent(dateFiltered);//recent first
          //console.log("final::::",this.logs);
        } else {
          this.logs = [];
        }
      }
    }
  }

  mostRecent(records: any){
    if (records) {
      if (records.length > 0) {
        return records.sort(
          (a, b) => Date.parse(b.updatedAt) - Date.parse(a.updatedAt)
        );
      } else {
        return [];
      }
    }
  }

  pastDateToISO(days){
    var d = new Date();
    if(days >0){
      d.setDate(d.getDate() - days)
    }
    return new Date(d.setHours(0,0,0,0)).toISOString();
  }

  applyDateFilter(logsTyped: any){
    if(this.dateSortSelection && this.dateSortSelection !="Most recent"){
      let datToday = Date.parse(this.pastDateToISO(0));
      let yesterday = Date.parse(this.pastDateToISO(1));
      let lastThirty = Date.parse(this.pastDateToISO(30));
      
      let filteredDateLog =[];
      if(logsTyped && logsTyped.length>0){
        filteredDateLog = logsTyped.filter((rec:any) => {
          let received = Date.parse(rec.updatedAt);
          // console.log(rec.updatedAt,
          //   this.pastDateToISO(0),
          //   this.pastDateToISO(1))
          // console.log("-----");
          //Most recent
          if(this.dateSortSelection == "Today"){
            if(received > datToday){ //today
              return rec;
            }
          } else if(this.dateSortSelection == "Yesterday"){
            if(received < datToday && received > yesterday){ //only yesterday
              return rec;
            }
          } else if(this.dateSortSelection == "Last 30 days"){
            if(received < datToday && received > lastThirty){ //last Thirty days
              return rec;
            }
          }
          //custom
        });
      }
      return filteredDateLog;
    }else{
      return logsTyped;
    }
  }

  async logActions(event: CustomEvent) {
    const popoverLog = await this.popoverCtrl.create({
      component: ActivityLogActionsComponent,
      event: event,
      cssClass: "popover-setting-log-actions",
      componentProps: { action: this.actionTypes, open: "logActions" },
      showBackdrop: false,
      side: "bottom",
      alignment: "start"
    });
    await popoverLog.present();
    // catch on did dismiss
    const result = await popoverLog.onDidDismiss();//.finally(()=>popoverLog.remove());
    if (result.data) {
      //console.log(result, result.data);
      this.actionTypes = result.data;
      //console.log("received parent", this.actionTypes);

      this.trueTypes = Object.keys(this.actionTypes).filter(e => this.actionTypes[e] == true);
      //['user','application','department','program','payment']

      let logsObj = this.logsFromApi;
      this.applyFilters(logsObj);
    }
  }

  async dateActions(event: CustomEvent) {
    const popoverDelete = await this.popoverCtrl.create({
      component: ActivityLogActionsComponent,
      event: event,
      cssClass: "popover-setting-date-actions",
      componentProps: { action: this.dateSortSelection || "", open: "dateActions" },
      showBackdrop: false,
      side: "bottom",
      alignment: "end"
    });
    await popoverDelete.present();
    // catch on did dismiss
    const result = await popoverDelete.onDidDismiss();
    if (result.data) {
      //console.log(result, result.data);
      this.dateSortSelection = result.data;
      //console.log("received parent date action", this.dateSortSelection);

      let logsObj = this.logsFromApi;
      this.applyFilters(logsObj);
    }
  }

  async adminActions(event: CustomEvent) {
    const popoverAdmin = await this.popoverCtrl.create({
      component: ActivityLogActionsComponent,
      event: event,
      cssClass: "popover-setting-admin-actions",
      componentProps: { 
        action: this.selectedAdmins || [], 
        open: "adminActions",
        adminList: this.adminList
      },
      showBackdrop: false,
      side: "bottom",
      alignment: "start"
    });
    await popoverAdmin.present();
    // catch on did dismiss
    const result = await popoverAdmin.onDidDismiss();
    if (result.data) {
      //console.log(result, result.data);
      this.selectedAdmins = result.data;
      //console.log("received parent", this.selectedAdmins);
      let logsObj = this.logsFromApi;
      this.applyFilters(logsObj);
    }
  }

  linkDisplay(actionName){
    //['user','application','department','program','payment']
    const displayables = ['application','program'];
    if(actionName && displayables.indexOf(actionName)> -1){
      return true;
    }
    return false;
  }

  openLink(dataObj:any){
    console.log(dataObj);
    if(dataObj && dataObj.json_data){
      const jsonData = dataObj.json_data;
      const moduleName = jsonData.action || "";
      console.log(moduleName);

      //['user','application','department','program','payment']
      if (moduleName=="application") {
        if(jsonData.application_id){
          this.route.navigate([
            `/new-application/details/${jsonData.application_id}/application-quick-summary`
          ]); 
        }else{
          console.log("not sure, not found proper id", dataObj);
        }
      }
      else if(moduleName=="department"){
        if(jsonData.department_id && jsonData.department_id!="TEST_VALID_DEPARTMENT_ID"){
          this.route.navigate(
            [`/institutions/details/institutions-information`, jsonData.department_id],
            {
              queryParams: {
                id: jsonData.department_id
              }
            }
          );
        }else{
          console.log("not sure, not found proper id", dataObj);
        }
        //object not found
      }
      else if(moduleName=="program"){
        if(jsonData.program_id && jsonData.program_id!="TEST_VALID_PROGRAM_ID"){
          this.route.navigate([`/programs/details/${jsonData.program_id}`]);
        }else{
          console.log("not sure, not found proper id", dataObj);
        }
        //TEST_VALID_PROGRAM_ID
      } else if(moduleName=="user"){
        if(jsonData.user_id && jsonData.user_id!="TEST_VALID_USER_ID"){
          this.route.navigate([
            `/trainees/details/${jsonData.user_id}/trainee-information`
          ]);
        }else{
          console.log("not sure, not found proper id", dataObj);
        }
        //"TEST_VALID_USER_ID"
        //user_id: 7777771
        //actual would be 009f1362-7f5c-49b3-9528-3b1ec4167bec
        //not matched
      } else if(moduleName=="payment"){
        if(jsonData.payment_id && jsonData.payment_id!="TEST_VALID_PAYMENT_ID"){
          this.route.navigate([`/payments/details/${jsonData.payment_id}`]);
        }else{
          console.log("not sure, not found proper id", dataObj);
        }
        //payment_id: "TEST_VALID_PAYMENT_ID"
        //100000229
        //actual 000a9efe-fd75-4a93-bd7b-1b6699929eea
      }
      
      // this.route.navigate(["/hosts/details/edit"], {
      //   queryParams: {
      //     id: this.params.data.departmentid,
      //     hostid: this.params.data.id
      //   }
      // });
    }
  }
}
